<template>
<div>
  <img id="bg" alt="">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-7 col-lg-5">
        <div class="login" v-if="resetPassword">
          <div id="img">
            <img class="image_stars" src="../../assets/purapura_background.jpg"  alt="logo">
            <img class="image_logo" src="../../assets/pura_logo.png"  alt="logo_text">
          </div>


            <div class="login-form-container ">
              <h2 class="portal-title">Reset Password</h2>
                <div class="d-flex justify-content-center"><div v-if="loading" class="spinner-border text-danger" role="status"></div></div>
              <div>
                  <b-form-input type="email" class="input-control" id="email"
                          placeholder="Tomo īmēra (Enter email)" v-model="email" required/>
              </div>
              <div class="text-danger text-center" v-if="error"><p>{{this.errorMessage}}</p></div>

              <b-button class="btn btn-block form-button" id="button-login" type="submit" @click="toForgotPassword()">Next</b-button>
              <b-button class="btn btn-block form-button" type="submit" @click="toLogInPage()">Back</b-button>
            </div>
        </div>

        <div class="login" v-if="forgotPassword">
          <div class="h1">
            Forgot password
          </div>
          <div class="alert alert-success" role="alert">
            We have sent you instructions to {{this.email}} on how to reset your password.
          </div>
          <div>
          You should receive the email fairly quickly. If you can’t find it, try checking your spam folder.
          </div>
        <button @click="toLogInPage()">Sign In</button>
        </div>

      </div>
      </div>
    </div>
</div>
</template>

<script>

import api from "@/services/api/api";

const ResetPasswordComponent = {
  name: "login",
  data() {
    return {
      error: null,
      email: "",
      isLogged: false,
      errorMessage: "",
      loading: false,
      resetPassword: true,
      forgotPassword: false
    };
  },

  /**
   * Clear the localStorage (logs out the user) and set isLogged to false.
   */
  created() {
    this.isLogged = false;
    sessionStorage.clear();
  },
  
  methods: {

    /**
     * Reroutes the user to the login page
     */
    toLogInPage(){
      this.$router.push({name: 'clientLogin'})
    },

    /**
     * Sends reset password request to the email provided
     */
    toForgotPassword(){
      var emailRegEx = /[a-zA-Z0-9]+@[a-zA-Z0-9]+.[a-zA-Z]+/;

      this.error = false;
      this.errorMessage = "";
      this.loading = true


      if (!emailRegEx.test(this.email)) {
        this.errorMessage = "Wrong Email Format";
        this.error = true;
        this.loading = false;
      } else{
        let payload = {
          email:this.email
        }

        api.users.resetPassword(payload)
        .then((res) =>{
          console.log(res)
          console.log("here")
          this.resetPassword = false
          this.forgotPassword = true
        }).catch(err => {
          this.error = true
          this.errorMessage = err.response.statusText
          this.loading = false
        })
      }
    }
  }
}


export default ResetPasswordComponent;
</script>

<style scoped>
@import '../../assets/styles/login.css';

</style>


